import React from "react";
import "./style.css";

const Loader = () => {
    return <span>Loading...</span>;
};

export default Loader;
